/**
 * dog-photo.js
 */

import React from 'react';
import axios from 'axios';
import 'canvas-toBlob/canvas-toBlob';
import { useSnackbar } from 'notistack';
import { shouldRenderMobileLayout } from 'utils/app-context';
import PhotoEditor from 'components/photo-editor';
import Button from 'components/button';
import DrawerContent from 'components/menu-drawer/drawer-content';
import DesktopContentHeader from 'components/menu-drawer/desktop-content-header';
import ConfirmUnsavedEditor from 'components/menu-drawer/confirm-unsaved-editor';
import DogDrawerMobileHeader from './dog-drawer-mobile-header';
import DrawerActionButton from 'components/menu-drawer/drawer-action-button';


const DogPhoto = function(props) {
  const {
    drawerState,
    dog,
    basePath,
    onSave
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [photoRef, setPhotoRef] = React.useState();
  const [isDirty, setIsDirty] = React.useState(false);
  const contentLoading = drawerState.loading.content.get();


  React.useEffect(() => {
    if (!dog) return;
    
    if (contentLoading) {
      drawerState.loading.set({ menu: false, content: false });
    }

  // drawerState causes infinite loop
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dog, contentLoading]);


  const photoChanged = (ref) => {
    if (ref) {
      setIsDirty(true);
      setPhotoRef(ref);
    }
  }

  const savePhoto = async () => {    
    try {
      if (!photoRef) {
        return;
      }

      drawerState.loading.content.set(true);
      const blob = await new Promise(resolve => photoRef
        .getImageScaledToCanvas()
        .toBlob(resolve, 'image/png', 1.0));

      let formData = new FormData();
      formData.append('photo', blob);
      const response = await axios.put(`/dogs/${dog.id}/photo`, formData);
      
      setIsDirty(false);
      onSave({ ...dog, photo: response.data });
      enqueueSnackbar('Dog photo saved', { variant: 'success' });
    } catch (error) {
      console.error('Failed to save photo:', error);
    } finally {
      drawerState.loading.content.set(false);
    }
  }


  const saveButton = (
    <DrawerActionButton
      level={1}
      type="submit"
      disabled={!isDirty}
      onClick={savePhoto}
    >
      Save
    </DrawerActionButton>
  );

  return (
    <>
      {/* mobile header */}
      {shouldRenderMobileLayout() &&
      <DogDrawerMobileHeader
        title="Photo"
        onClose={props.onClose}
        saveButton={saveButton}
        basePath={basePath}
      />}

      {/* desktop header */}
      {!shouldRenderMobileLayout() &&
      <DesktopContentHeader
        title="Photo"
        actions={(<>
          <Button upperCase={false} onClick={props.onClose}>Cancel</Button>
          {saveButton}
        </>)} 
      />}

      <DrawerContent>
        <div className='flex-hc' style={{ flexDirection: 'column' }}>
          {dog &&
          <PhotoEditor
            key={dog.id}
            photo={dog.photo}
            onChange={photoChanged}
          />}
        </div>
      </DrawerContent>

      <ConfirmUnsavedEditor
        dirty={isDirty}
        save={() => savePhoto()}
      />

    </>
  );
}

export default DogPhoto;